<a
  *ngIf="customer"
  class="button-ghost"
  [routerLink]="['/extensions/ui-customer', customer.id]"
  target="_blank"
>
  <clr-icon shape="user" [class.is-solid]="customer"></clr-icon>
  <span>{{ customer.firstName }} </span>
  <clr-icon shape="arrow right"></clr-icon>
</a>
<div *ngIf="!customer">{{ "common.guest" | translate }}</div>
